import { forwardRef } from "react";

import { useSiteData } from "../../contexts/SiteDataContext";

const MainPageInfo = forwardRef<HTMLElement>((_props, ref) => {
  const { siteData } = useSiteData();

  return (
    <section ref={ref} className="w-full footer-bg-image text-white">
      <div className="container-md 2xl:px-0 px-3 mx-auto pt-16 pb-16 md:pt-[7.5rem] md:pb-[7.5rem] min-h-[31.25rem]">
        <h2 className="text-[1.5rem] md:text-[2rem] font-bold leading-[120%] tracking-[0.01em] text-dark mb-3 text-left md:text-center">
          {siteData?.our_criteria?.title}
        </h2>

        <div
          dangerouslySetInnerHTML={{
            __html: siteData?.our_criteria?.content ?? "",
          }}
          className="mb-[3.75rem]"
        />

        <div className="flex justify-center">
          <a
            href="/protocol"
            className="button inline-block bg-yellow text-sm md:text-lg font-extrabold leading-0 rounded-lg text-center py-4 px-12 md:py-6"
            data-umami-event="Main Page Details Click"
          >
            Узнать детальнее
          </a>
        </div>
      </div>
    </section>
  );
});

MainPageInfo.displayName = "MainPageInfo";

export default MainPageInfo;
